module.exports = __webpack_public_path__ + "img/ppt.c54bf0bd.svg";